import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[85vh] md:min-h-screen flex items-end md:items-center justify-center overflow-hidden bg-black pt-4 md:pt-20" data-id="element-162">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-163">
        {/* Placeholder for Hero Image: Family or kids training together */}
        <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?q=80&w=2072&auto=format&fit=crop" alt="Martial Arts Training" className="w-full h-full object-cover opacity-40" data-id="element-164" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-165" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 md:py-0" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-167">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] text-sm font-semibold mb-6 backdrop-blur-sm" data-id="element-168">
            <span className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" data-id="element-169" />
            Serving Bloomington Since 1999
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-170">
            Build <span className="text-[#00D4FF]" data-id="element-171">Confidence</span>, <br data-id="element-172" />
            Discipline & Strength
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 font-light max-w-2xl leading-relaxed" data-id="element-173">
            Where families kick together. Experience the life-changing benefits
            of martial arts in our new state-of-the-art facility.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-174">
            <a href="#schedule" className="group bg-[#00D4FF] text-black px-8 py-4 rounded font-bold text-lg uppercase tracking-wider hover:bg-[#33ddff] transition-all flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)]" data-id="element-175">
              Schedule Free Trial
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-176" />
            </a>

            <a href="#programs" className="group px-8 py-4 rounded font-bold text-lg uppercase tracking-wider text-white border border-white/30 hover:bg-white/10 transition-all flex items-center justify-center gap-2 backdrop-blur-sm" data-id="element-177">
              View Programs
              <ChevronRight className="w-5 h-5 text-[#00D4FF] group-hover:translate-x-1 transition-transform" data-id="element-178" />
            </a>
          </div>

          <div className="mt-12 flex items-center gap-8 text-sm text-gray-400 font-medium" data-id="element-179">
            <div className="flex items-center gap-2" data-id="element-180">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-181" />
              <span data-id="element-182">Ages 3 to Adult</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-183">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-184" />
              <span data-id="element-185">No Experience Needed</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-186">
              <div className="w-1 h-1 bg-[#00D4FF] rounded-full" data-id="element-187" />
              <span data-id="element-188">Family Discounts</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}